//the key for each of these is the matching genre id that comes TMDB

const CardImage = {
  12: require("components/Data/images/I12.jpg").default,
  14: require("components/Data/images/I14.jpg").default,
  16: require("components/Data/images/I16.jpg").default,
  18: require("components/Data/images/I18.jpg").default,
  27: require("components/Data/images/I27.jpg").default,
  28: require("components/Data/images/I28.jpg").default,
  35: require("components/Data/images/I35.jpg").default,
  36: require("components/Data/images/I36.jpg").default,
  37: require("components/Data/images/I37.jpg").default,
  53: require("components/Data/images/I53.jpg").default,
  80: require("components/Data/images/I80.jpg").default,
  99: require("components/Data/images/I99.jpg").default,
  878: require("components/Data/images/I878.jpg").default,
  9648: require("components/Data/images/I9648.jpg").default,
  10402: require("components/Data/images/I10402.jpg").default,
  10749: require("components/Data/images/I10749.jpg").default,
  10751: require("components/Data/images/I10751.jpg").default,
  10752: require("components/Data/images/I10752.jpg").default,
  10770: require("components/Data/images/I10770.jpg").default,
};

export default CardImage;
